import { render, staticRenderFns } from "./ConfigIntegrationPersonTypeDetails.vue?vue&type=template&id=7935dcaa&scoped=true&"
import script from "./ConfigIntegrationPersonTypeDetails.vue?vue&type=script&lang=js&"
export * from "./ConfigIntegrationPersonTypeDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIntegrationPersonTypeDetails.vue?vue&type=style&index=0&id=7935dcaa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7935dcaa",
  null
  
)

export default component.exports